import React from "react";
import { ReportRule } from "./ReportRule";
import { PAYMENT_INSTRUCTIONS_CUSTOMER_TITLE } from "../../helpers/invoicePaymentInstructions";

/**
 * Renders a structured paymentInstructions presentation model.
 * Does not assemble wording from raw storage — blocks come from the helper.
 * Payment-method agnostic: only consumes title + blocks.
 */
export function ReportPaymentInstructionsSection({
  paymentInstructions,
  variant = "print",
}) {
  if (!paymentInstructions?.blocks?.length) return null;

  const isPrint = variant === "print";
  const titleClassName = isPrint ? "erp-section-title" : "er-section-title";
  const fieldClassName = isPrint
    ? "erp-payment-field"
    : "er-payment-field";
  const labelClassName = isPrint
    ? "erp-payment-label"
    : "er-payment-label";
  const valueClassName = isPrint
    ? "erp-payment-value"
    : "er-payment-value";
  const textClassName = isPrint ? "erp-notes" : "er-notes";

  const content = (
    <>
      <ReportRule variant={variant} />
      <h2 className={titleClassName}>
        {paymentInstructions.title || PAYMENT_INSTRUCTIONS_CUSTOMER_TITLE}
      </h2>
      <div
        className={
          isPrint
            ? "erp-payment-instructions"
            : "er-payment-instructions"
        }
      >
        {paymentInstructions.blocks.map((block, index) => {
          if (block.type === "field") {
            return (
              <div key={`field-${index}`} className={fieldClassName}>
                <div className={labelClassName}>{block.label}</div>
                <div className={valueClassName}>{block.value}</div>
              </div>
            );
          }

          if (block.type === "text") {
            return (
              <p key={`text-${index}`} className={textClassName}>
                {block.text}
              </p>
            );
          }

          return null;
        })}
      </div>
    </>
  );

  if (isPrint) {
    return (
      <section className="erp-section erp-break-avoid">{content}</section>
    );
  }

  return content;
}
